export default {
      id: "arrow_thin_top-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#arrow_thin_top",
      toString: function () {
        return this.url;
      }
    }